__turbopack_context__.v({
  "old-versions": "ZdbMfq_old-versions",
  "terms": "ZdbMfq_terms",
});
